/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const trackEvent = /* GraphQL */ `
  mutation TrackEvent($input: TrackEventInput!) {
    trackEvent(input: $input)
  }
`;
export const createClient = /* GraphQL */ `
  mutation CreateClient($input: CreateClientInput!) {
    createClient(input: $input) {
      id
      entityId
      userId
      firmId
      email
      invitedEmail
      ocrEmail
      referredBy
      invitedEntityId
      firmEntityId
      providerContactId
      ownerCode
      clientGroupCode
      clientCode
      firstName
      lastName
      role
      jobTags
      paymentsEnabled
      termsInvoiceAccepted
      termsOcrAccepted
      termsFirmPayTaxAccepted
      termsFirmPayTaxDetails {
        document {
          identityId
          key
          level
          type
          name
        }
        acceptedAt
        email
        ip
        fullName
        firmId
      }
      entitySearchName
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      firm {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      searchName
      taxNumber
      taskSendSMS
      companyNumber
      createdBy
      createdAt
      updatedAt
      status
      partnerId
      managerId
      archivedAt
      taxPaymentReferences {
        itr {
          referenceNumber
          updatedAt
        }
        other {
          referenceNumber
          updatedAt
        }
      }
    }
  }
`;
export const createClientBulkUpload = /* GraphQL */ `
  mutation CreateClientBulkUpload($input: CreateClientBulkImportInput!) {
    createClientBulkUpload(input: $input)
  }
`;
export const addClientOwner = /* GraphQL */ `
  mutation AddClientOwner($input: AddClientOwnerInput!) {
    addClientOwner(input: $input) {
      success
      entityId
      userId
      ownerEntityUserId
      clientGroupCode
      clientCode
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      entityUser {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id
      entityId
      xeroTenantId
      entityType
      firstName
      lastName
      email
      mobile
      phone
      taxNumber
      companyNumber
      name
      legalName
      searchName
      status
      website
      createdAt
      updatedAt
      contactType
      bank {
        id
        accountName
        bankName
        accountNumber
        routingNumber
        holderType
        accountType
        country
      }
      bpay {
        billerCode
        referenceNumber
      }
      invalidFields
      bulkUploadFileKey
      owner
      createdBy
      beneficiaryBankId
      beneficiaryBpayId
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      postal {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      payoutErrors
    }
  }
`;
export const createContactBulkUpload = /* GraphQL */ `
  mutation CreateContactBulkUpload($input: CreateContactBulkImportInput!) {
    createContactBulkUpload(input: $input)
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      id
      entityId
      xeroTenantId
      entityType
      firstName
      lastName
      email
      mobile
      phone
      taxNumber
      companyNumber
      name
      legalName
      searchName
      status
      website
      createdAt
      updatedAt
      contactType
      bank {
        id
        accountName
        bankName
        accountNumber
        routingNumber
        holderType
        accountType
        country
      }
      bpay {
        billerCode
        referenceNumber
      }
      invalidFields
      bulkUploadFileKey
      owner
      createdBy
      beneficiaryBankId
      beneficiaryBpayId
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      postal {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      payoutErrors
    }
  }
`;
export const resendUserTemporaryPassword = /* GraphQL */ `
  mutation ResendUserTemporaryPassword(
    $input: ResendUserTemporaryPasswordInput!
  ) {
    resendUserTemporaryPassword(input: $input)
  }
`;
export const createDocumentAnalysis = /* GraphQL */ `
  mutation CreateDocumentAnalysis($input: CreateDocumentAnalysisInput) {
    createDocumentAnalysis(input: $input) {
      id
      entityId
      firmId
      fileKey
      documents {
        identityId
        key
        level
        type
        name
      }
      status
      expenseStatus
      queryStatus
      matchedBiller {
        billerCode
        billerCategory
        shortName
        longName
        type
        industryCode
        industryCodeDescription
        createdAt
        updatedAt
      }
      matchedContactId
      matchedContact {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
      matchedEntityId
      matchedEntity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      newContact {
        firstName
        lastName
        email
        mobile
        phone
        name
        taxNumber
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
      }
      task {
        reference
        dueAt
        issuedAt
        lodgementAt
        paymentAt
        gstInclusive
        notes
        amount
        gstAmount
        taxAmount
        lineItems {
          description
          quantity
          unitPrice
          price
          productCode
          taxType
        }
        numberOfPayments
        paymentFrequency
        shippingAmount
        settlementStatus
        partnerId
        managerId
        documentType
        subCategory
        category
        period
        year
      }
      bpay {
        billerCode
        referenceNumber
      }
      bank {
        accountNumber
        routingNumber
      }
      category
      source
      isCorrect
      fromEmail
      textContent
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const updateDocumentAnalysis = /* GraphQL */ `
  mutation UpdateDocumentAnalysis($input: UpdateDocumentAnalysisInput) {
    updateDocumentAnalysis(input: $input) {
      id
      entityId
      firmId
      fileKey
      documents {
        identityId
        key
        level
        type
        name
      }
      status
      expenseStatus
      queryStatus
      matchedBiller {
        billerCode
        billerCategory
        shortName
        longName
        type
        industryCode
        industryCodeDescription
        createdAt
        updatedAt
      }
      matchedContactId
      matchedContact {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
      matchedEntityId
      matchedEntity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      newContact {
        firstName
        lastName
        email
        mobile
        phone
        name
        taxNumber
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
      }
      task {
        reference
        dueAt
        issuedAt
        lodgementAt
        paymentAt
        gstInclusive
        notes
        amount
        gstAmount
        taxAmount
        lineItems {
          description
          quantity
          unitPrice
          price
          productCode
          taxType
        }
        numberOfPayments
        paymentFrequency
        shippingAmount
        settlementStatus
        partnerId
        managerId
        documentType
        subCategory
        category
        period
        year
      }
      bpay {
        billerCode
        referenceNumber
      }
      bank {
        accountNumber
        routingNumber
      }
      category
      source
      isCorrect
      fromEmail
      textContent
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteDocumentAnalysis = /* GraphQL */ `
  mutation DeleteDocumentAnalysis($input: DeleteDocumentAnalysisInput) {
    deleteDocumentAnalysis(input: $input) {
      id
      entityId
      firmId
      fileKey
      documents {
        identityId
        key
        level
        type
        name
      }
      status
      expenseStatus
      queryStatus
      matchedBiller {
        billerCode
        billerCategory
        shortName
        longName
        type
        industryCode
        industryCodeDescription
        createdAt
        updatedAt
      }
      matchedContactId
      matchedContact {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
      matchedEntityId
      matchedEntity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      newContact {
        firstName
        lastName
        email
        mobile
        phone
        name
        taxNumber
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
      }
      task {
        reference
        dueAt
        issuedAt
        lodgementAt
        paymentAt
        gstInclusive
        notes
        amount
        gstAmount
        taxAmount
        lineItems {
          description
          quantity
          unitPrice
          price
          productCode
          taxType
        }
        numberOfPayments
        paymentFrequency
        shippingAmount
        settlementStatus
        partnerId
        managerId
        documentType
        subCategory
        category
        period
        year
      }
      bpay {
        billerCode
        referenceNumber
      }
      bank {
        accountNumber
        routingNumber
      }
      category
      source
      isCorrect
      fromEmail
      textContent
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const createEntity = /* GraphQL */ `
  mutation CreateEntity($input: CreateEntityInput!) {
    createEntity(input: $input) {
      id
      type
      taxNumber
      companyNumber
      billerCode
      name
      legalName
      businessNames
      searchName
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      logo {
        alt
        identityId
        key
        level
        type
      }
      brandColour
      website
      entityUsers {
        items {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        nextToken
      }
      gstRegistered
      gstReportingPeriod
      providerEntityId
      providerCompanyId
      providerBillUserCompanyId
      providerBankAccountId
      providerDigitalWalletId
      providerBpayCrn
      contact {
        firstName
        lastName
        email
        phone
        role
      }
      paymentMethods {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      paymentMethodId
      paymentUserId
      disbursementMethodId
      receivingAccounts {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      ubosCreated
      numUbosCreated
      subCategory
      clientsStatus
      ocrEmail
      termsInvoiceAccepted
      termsOcrAccepted
      owner
      referredBy
      connectedAccount
      accountStatus
      customerId
      xeroSyncStatus
      xeroLastContactSyncAt
      xeroContactSyncStatus
      xeroInvoiceSyncStatus
      xeroLastInvoiceSyncAt
      xeroTenantId
      absorbFees
      subscriptionTier
      invitationStatus
      clientsOnboardingStatus
      createdBy
      createdByEntityId
      isFirm
      createdAt
      updatedAt
    }
  }
`;
export const updateEntity = /* GraphQL */ `
  mutation UpdateEntity($input: UpdateEntityInput!) {
    updateEntity(input: $input) {
      id
      type
      taxNumber
      companyNumber
      billerCode
      name
      legalName
      businessNames
      searchName
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      logo {
        alt
        identityId
        key
        level
        type
      }
      brandColour
      website
      entityUsers {
        items {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        nextToken
      }
      gstRegistered
      gstReportingPeriod
      providerEntityId
      providerCompanyId
      providerBillUserCompanyId
      providerBankAccountId
      providerDigitalWalletId
      providerBpayCrn
      contact {
        firstName
        lastName
        email
        phone
        role
      }
      paymentMethods {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      paymentMethodId
      paymentUserId
      disbursementMethodId
      receivingAccounts {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      ubosCreated
      numUbosCreated
      subCategory
      clientsStatus
      ocrEmail
      termsInvoiceAccepted
      termsOcrAccepted
      owner
      referredBy
      connectedAccount
      accountStatus
      customerId
      xeroSyncStatus
      xeroLastContactSyncAt
      xeroContactSyncStatus
      xeroInvoiceSyncStatus
      xeroLastInvoiceSyncAt
      xeroTenantId
      absorbFees
      subscriptionTier
      invitationStatus
      clientsOnboardingStatus
      createdBy
      createdByEntityId
      isFirm
      createdAt
      updatedAt
    }
  }
`;
export const regenerateEntityOcrEmail = /* GraphQL */ `
  mutation RegenerateEntityOcrEmail($input: RegenerateEntityOcrEmailInput!) {
    regenerateEntityOcrEmail(input: $input) {
      id
      type
      taxNumber
      companyNumber
      billerCode
      name
      legalName
      businessNames
      searchName
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      logo {
        alt
        identityId
        key
        level
        type
      }
      brandColour
      website
      entityUsers {
        items {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        nextToken
      }
      gstRegistered
      gstReportingPeriod
      providerEntityId
      providerCompanyId
      providerBillUserCompanyId
      providerBankAccountId
      providerDigitalWalletId
      providerBpayCrn
      contact {
        firstName
        lastName
        email
        phone
        role
      }
      paymentMethods {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      paymentMethodId
      paymentUserId
      disbursementMethodId
      receivingAccounts {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      ubosCreated
      numUbosCreated
      subCategory
      clientsStatus
      ocrEmail
      termsInvoiceAccepted
      termsOcrAccepted
      owner
      referredBy
      connectedAccount
      accountStatus
      customerId
      xeroSyncStatus
      xeroLastContactSyncAt
      xeroContactSyncStatus
      xeroInvoiceSyncStatus
      xeroLastInvoiceSyncAt
      xeroTenantId
      absorbFees
      subscriptionTier
      invitationStatus
      clientsOnboardingStatus
      createdBy
      createdByEntityId
      isFirm
      createdAt
      updatedAt
    }
  }
`;
export const deleteEntity = /* GraphQL */ `
  mutation DeleteEntity(
    $input: DeleteEntityInput!
    $condition: ModelEntityConditionInput
  ) {
    deleteEntity(input: $input, condition: $condition) {
      id
      type
      taxNumber
      companyNumber
      billerCode
      name
      legalName
      businessNames
      searchName
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      logo {
        alt
        identityId
        key
        level
        type
      }
      brandColour
      website
      entityUsers {
        items {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        nextToken
      }
      gstRegistered
      gstReportingPeriod
      providerEntityId
      providerCompanyId
      providerBillUserCompanyId
      providerBankAccountId
      providerDigitalWalletId
      providerBpayCrn
      contact {
        firstName
        lastName
        email
        phone
        role
      }
      paymentMethods {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      paymentMethodId
      paymentUserId
      disbursementMethodId
      receivingAccounts {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      ubosCreated
      numUbosCreated
      subCategory
      clientsStatus
      ocrEmail
      termsInvoiceAccepted
      termsOcrAccepted
      owner
      referredBy
      connectedAccount
      accountStatus
      customerId
      xeroSyncStatus
      xeroLastContactSyncAt
      xeroContactSyncStatus
      xeroInvoiceSyncStatus
      xeroLastInvoiceSyncAt
      xeroTenantId
      absorbFees
      subscriptionTier
      invitationStatus
      clientsOnboardingStatus
      createdBy
      createdByEntityId
      isFirm
      createdAt
      updatedAt
    }
  }
`;
export const createEntityUser = /* GraphQL */ `
  mutation CreateEntityUser($input: CreateEntityUserInput!) {
    createEntityUser(input: $input) {
      id
      entityId
      userId
      firmId
      email
      invitedEmail
      ocrEmail
      referredBy
      invitedEntityId
      firmEntityId
      providerContactId
      ownerCode
      clientGroupCode
      clientCode
      firstName
      lastName
      role
      jobTags
      paymentsEnabled
      termsInvoiceAccepted
      termsOcrAccepted
      termsFirmPayTaxAccepted
      termsFirmPayTaxDetails {
        document {
          identityId
          key
          level
          type
          name
        }
        acceptedAt
        email
        ip
        fullName
        firmId
      }
      entitySearchName
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      firm {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      searchName
      taxNumber
      taskSendSMS
      companyNumber
      createdBy
      createdAt
      updatedAt
      status
      partnerId
      managerId
      archivedAt
      taxPaymentReferences {
        itr {
          referenceNumber
          updatedAt
        }
        other {
          referenceNumber
          updatedAt
        }
      }
    }
  }
`;
export const updateEntityUser = /* GraphQL */ `
  mutation UpdateEntityUser($input: UpdateEntityUserInput!) {
    updateEntityUser(input: $input) {
      id
      entityId
      userId
      firmId
      email
      invitedEmail
      ocrEmail
      referredBy
      invitedEntityId
      firmEntityId
      providerContactId
      ownerCode
      clientGroupCode
      clientCode
      firstName
      lastName
      role
      jobTags
      paymentsEnabled
      termsInvoiceAccepted
      termsOcrAccepted
      termsFirmPayTaxAccepted
      termsFirmPayTaxDetails {
        document {
          identityId
          key
          level
          type
          name
        }
        acceptedAt
        email
        ip
        fullName
        firmId
      }
      entitySearchName
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      firm {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      searchName
      taxNumber
      taskSendSMS
      companyNumber
      createdBy
      createdAt
      updatedAt
      status
      partnerId
      managerId
      archivedAt
      taxPaymentReferences {
        itr {
          referenceNumber
          updatedAt
        }
        other {
          referenceNumber
          updatedAt
        }
      }
    }
  }
`;
export const acceptDenyEntityUserStatus = /* GraphQL */ `
  mutation AcceptDenyEntityUserStatus(
    $input: AcceptDenyEntityUserStatusInput!
  ) {
    acceptDenyEntityUserStatus(input: $input) {
      id
      entityId
      userId
      firmId
      email
      invitedEmail
      ocrEmail
      referredBy
      invitedEntityId
      firmEntityId
      providerContactId
      ownerCode
      clientGroupCode
      clientCode
      firstName
      lastName
      role
      jobTags
      paymentsEnabled
      termsInvoiceAccepted
      termsOcrAccepted
      termsFirmPayTaxAccepted
      termsFirmPayTaxDetails {
        document {
          identityId
          key
          level
          type
          name
        }
        acceptedAt
        email
        ip
        fullName
        firmId
      }
      entitySearchName
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      firm {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      searchName
      taxNumber
      taskSendSMS
      companyNumber
      createdBy
      createdAt
      updatedAt
      status
      partnerId
      managerId
      archivedAt
      taxPaymentReferences {
        itr {
          referenceNumber
          updatedAt
        }
        other {
          referenceNumber
          updatedAt
        }
      }
    }
  }
`;
export const sendReferralInvitationEmail = /* GraphQL */ `
  mutation SendReferralInvitationEmail(
    $input: sendReferralInvitationEmailInput!
  ) {
    sendReferralInvitationEmail(input: $input)
  }
`;
export const deleteEntityUser = /* GraphQL */ `
  mutation DeleteEntityUser($input: DeleteEntityUserInput) {
    deleteEntityUser(input: $input) {
      id
      entityId
      userId
      firmId
      email
      invitedEmail
      ocrEmail
      referredBy
      invitedEntityId
      firmEntityId
      providerContactId
      ownerCode
      clientGroupCode
      clientCode
      firstName
      lastName
      role
      jobTags
      paymentsEnabled
      termsInvoiceAccepted
      termsOcrAccepted
      termsFirmPayTaxAccepted
      termsFirmPayTaxDetails {
        document {
          identityId
          key
          level
          type
          name
        }
        acceptedAt
        email
        ip
        fullName
        firmId
      }
      entitySearchName
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      firm {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      searchName
      taxNumber
      taskSendSMS
      companyNumber
      createdBy
      createdAt
      updatedAt
      status
      partnerId
      managerId
      archivedAt
      taxPaymentReferences {
        itr {
          referenceNumber
          updatedAt
        }
        other {
          referenceNumber
          updatedAt
        }
      }
    }
  }
`;
export const createService = /* GraphQL */ `
  mutation CreateService($input: CreateServiceInput!) {
    createService(input: $input) {
      id
      entityId
      title
      description
      amount
      feeType
      taxType
      searchName
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateService = /* GraphQL */ `
  mutation UpdateService($input: UpdateServiceInput!) {
    updateService(input: $input) {
      id
      entityId
      title
      description
      amount
      feeType
      taxType
      searchName
      status
      createdAt
      updatedAt
    }
  }
`;
export const createTemplate = /* GraphQL */ `
  mutation CreateTemplate($input: CreateTemplateInput!) {
    createTemplate(input: $input) {
      id
      entityId
      title
      searchName
      templateJson
      templateHtml
      status
      canDelete
      type
      includeLetterhead
      createdAt
      updatedAt
    }
  }
`;
export const updateTemplate = /* GraphQL */ `
  mutation UpdateTemplate($input: UpdateTemplateInput!) {
    updateTemplate(input: $input) {
      id
      entityId
      title
      searchName
      templateJson
      templateHtml
      status
      canDelete
      type
      includeLetterhead
      createdAt
      updatedAt
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification($input: CreateNotificationInput) {
    createNotification(input: $input) {
      id
      title
      message
      status
      createdAt
      updatedAt
      type
      owner
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification($input: UpdateNotificationInput) {
    updateNotification(input: $input) {
      id
      title
      message
      status
      createdAt
      updatedAt
      type
      owner
    }
  }
`;
export const createOption = /* GraphQL */ `
  mutation CreateOption(
    $input: CreateOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    createOption(input: $input, condition: $condition) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateOption = /* GraphQL */ `
  mutation UpdateOption(
    $input: UpdateOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    updateOption(input: $input, condition: $condition) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const deleteOption = /* GraphQL */ `
  mutation DeleteOption(
    $input: DeleteOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    deleteOption(input: $input, condition: $condition) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment($input: CreatePaymentInput) {
    createPayment(input: $input) {
      id
      paymentIntentId
      taskId
      entityId
      payInPaymentId
      providerTransactionId
      paymentProvider
      disbursementId
      fromId
      fromType
      toId
      toType
      buyerId
      sellerId
      entityIdTo
      amount
      netAmount
      payerFees
      totalAmount
      gstAmount
      installment
      installments
      feeAmount
      reference
      paymentType
      taxAmount
      currency
      feeIds
      ipAddress
      status
      payerUserStatus
      declinedReason
      isUnlimitedRecurring
      payoutFailureReason
      payoutFailureFields
      payoutDetails {
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      scheduledAt
      paidAt
      declinedAt
      createdAt
      receivedAt
      paidOutAt
      updatedAt
      voidedAt
      owner
      payoutFailedAt
    }
  }
`;
export const createPaymentPayId = /* GraphQL */ `
  mutation CreatePaymentPayId($input: CreatePaymentPayIdInput) {
    createPaymentPayId(input: $input) {
      id
      entityId
      amount
      paymentType
      status
      taskPayments {
        id
        paymentType
        installments
        scheduledAt
      }
      scheduledAt
      createdBy
      paymentUserId
      receivedAt
      paidOutAt
      createdAt
      updatedAt
    }
  }
`;
export const cancelPaymentPayId = /* GraphQL */ `
  mutation CancelPaymentPayId($input: CancelPaymentPayIdInput) {
    cancelPaymentPayId(input: $input) {
      id
      paymentIntentId
      taskId
      entityId
      payInPaymentId
      providerTransactionId
      paymentProvider
      disbursementId
      fromId
      fromType
      toId
      toType
      buyerId
      sellerId
      entityIdTo
      amount
      netAmount
      payerFees
      totalAmount
      gstAmount
      installment
      installments
      feeAmount
      reference
      paymentType
      taxAmount
      currency
      feeIds
      ipAddress
      status
      payerUserStatus
      declinedReason
      isUnlimitedRecurring
      payoutFailureReason
      payoutFailureFields
      payoutDetails {
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      scheduledAt
      paidAt
      declinedAt
      createdAt
      receivedAt
      paidOutAt
      updatedAt
      voidedAt
      owner
      payoutFailedAt
    }
  }
`;
export const retryPayment = /* GraphQL */ `
  mutation RetryPayment($input: RetryPaymentInput) {
    retryPayment(input: $input) {
      id
      paymentIntentId
      taskId
      entityId
      payInPaymentId
      providerTransactionId
      paymentProvider
      disbursementId
      fromId
      fromType
      toId
      toType
      buyerId
      sellerId
      entityIdTo
      amount
      netAmount
      payerFees
      totalAmount
      gstAmount
      installment
      installments
      feeAmount
      reference
      paymentType
      taxAmount
      currency
      feeIds
      ipAddress
      status
      payerUserStatus
      declinedReason
      isUnlimitedRecurring
      payoutFailureReason
      payoutFailureFields
      payoutDetails {
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      scheduledAt
      paidAt
      declinedAt
      createdAt
      receivedAt
      paidOutAt
      updatedAt
      voidedAt
      owner
      payoutFailedAt
    }
  }
`;
export const createTaskPayment = /* GraphQL */ `
  mutation CreateTaskPayment($input: CreateTaskPaymentInput) {
    createTaskPayment(input: $input) {
      id
      paymentIntentId
      taskId
      entityId
      payInPaymentId
      providerTransactionId
      paymentProvider
      disbursementId
      fromId
      fromType
      toId
      toType
      buyerId
      sellerId
      entityIdTo
      amount
      netAmount
      payerFees
      totalAmount
      gstAmount
      installment
      installments
      feeAmount
      reference
      paymentType
      taxAmount
      currency
      feeIds
      ipAddress
      status
      payerUserStatus
      declinedReason
      isUnlimitedRecurring
      payoutFailureReason
      payoutFailureFields
      payoutDetails {
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      scheduledAt
      paidAt
      declinedAt
      createdAt
      receivedAt
      paidOutAt
      updatedAt
      voidedAt
      owner
      payoutFailedAt
    }
  }
`;
export const createPaymentMethod = /* GraphQL */ `
  mutation CreatePaymentMethod($input: CreatePaymentMethodInput) {
    createPaymentMethod(input: $input) {
      id
      paymentMethodType
      type
      fullName
      number
      expMonth
      expYear
      accountName
      bankName
      accountNumber
      routingNumber
      holderType
      accountType
      status
      accountDirection
      expiresAt
      createdAt
      updatedAt
      consentId
      consentStatus
      card
      googlepay
      applepay
    }
  }
`;
export const updatePaymentMethod = /* GraphQL */ `
  mutation UpdatePaymentMethod($input: UpdatePaymentMethodInput) {
    updatePaymentMethod(input: $input) {
      id
      paymentMethodType
      type
      fullName
      number
      expMonth
      expYear
      accountName
      bankName
      accountNumber
      routingNumber
      holderType
      accountType
      status
      accountDirection
      expiresAt
      createdAt
      updatedAt
      consentId
      consentStatus
      card
      googlepay
      applepay
    }
  }
`;
export const createPushNotification = /* GraphQL */ `
  mutation CreatePushNotification($input: CreatePushNotificationInput) {
    createPushNotification(input: $input)
  }
`;
export const createSignature = /* GraphQL */ `
  mutation CreateSignature($input: CreateSignatureInput) {
    createSignature(input: $input) {
      id
      userId
      key
      createdAt
      updatedAt
    }
  }
`;
export const deleteSignature = /* GraphQL */ `
  mutation DeleteSignature($input: DeleteSignatureInput) {
    deleteSignature(input: $input) {
      id
      userId
      key
      createdAt
      updatedAt
    }
  }
`;
export const createDocumentAnalysisDocumentUrl = /* GraphQL */ `
  mutation CreateDocumentAnalysisDocumentUrl(
    $input: CreateDocumentAnalysisDocumentUrlInput
  ) {
    createDocumentAnalysisDocumentUrl(input: $input) {
      url
      expiresAt
    }
  }
`;
export const acceptQuoteGuest = /* GraphQL */ `
  mutation AcceptQuoteGuest($input: AcceptQuoteInput) {
    acceptQuoteGuest(input: $input) {
      token
      updatedTask {
        id
        entityId
        amount
        taxAmount
        annotations
        documentType
        subCategory
        fromId
        linkedTaskId
        futureLinkedTask {
          fromId
          fromType
          from {
            id
            name
            taxNumber
            createdAt
            updatedAt
          }
          toId
          toType
          to {
            id
            name
            taxNumber
            createdAt
            updatedAt
          }
          numberOfPayments
          paymentFrequency
          reference
          bpayReferenceNumber
          amount
          gstInclusive
          lineItems {
            serviceId
            description
            quantity
            unitAmount
            taxType
            lineAmount
            newService
          }
          isUnlimitedRecurring
          direction
          invoiceStatus
          dueAt
          paymentAt
          lodgementAt
        }
        firm {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        fromEntity {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        from {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        fromContact {
          id
          firstName
          lastName
          name
          createdAt
          updatedAt
        }
        fromType
        toEntity {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toContact {
          id
          firstName
          lastName
          name
          createdAt
          updatedAt
        }
        toId
        to {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toType
        isFinalSigner
        status
        signatureStatus
        paymentStatus
        quoteStatus
        invoiceStatus
        settlementStatus
        type
        category
        documents {
          identityId
          key
          level
          type
          name
        }
        supportDocuments {
          identityId
          key
          level
          type
          name
        }
        numberOfPayments
        paymentFrequency
        paymentTypes
        reference
        bpayReferenceNumber
        createdBy
        gstInclusive
        entityIdBy
        dueAt
        issuedAt
        notes
        direction
        paymentAt
        lodgementAt
        readAt
        paidAt
        quoteAcceptedAt
        completedAt
        owner
        metaHashData
        automaticGenerateInvoice
        automaticInvoicePaymentAt
        automaticInvoicePaymentTerms
        quoteRequiresSignature
        automaticallyGeneratedFromQuote
        termsFirmPayTaxAccepted
        createdAt
        updatedAt
        token
        period
        year
      }
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask($input: CreateTaskInput) {
    createTask(input: $input) {
      entityId
      taskNumber
      invoiceStatus
      agreementUuid
      documentType
      subCategory
      id
      linkedTaskId
      managerId
      partnerId
      bindingId
      futureLinkedTask {
        fromId
        fromType
        toId
        toType
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      documentAnalysisId
      activity {
        items {
          id
          compositeId
          userId
          entityId
          type
          message
          metadata {
            name
            email
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      amount
      taxAmount
      annotations
      entityIdFrom
      fromId
      fromType
      toId
      toType
      firmId
      entityIdTo
      contactIdFrom
      contactIdTo
      contactId
      entityByIdContactId
      firmByIdContactId
      firmById
      searchName
      status
      quoteStatus
      signatureStatus
      paymentStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      emailMessage
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      maximumInstallments
      reference
      bpayReferenceNumber
      settlementStatus
      signers {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      otherRecipients {
        email
        sendOnCompletion
      }
      payments {
        items {
          id
          paymentIntentId
          taskId
          entityId
          payInPaymentId
          providerTransactionId
          paymentProvider
          disbursementId
          fromId
          fromType
          toId
          toType
          buyerId
          sellerId
          entityIdTo
          amount
          netAmount
          payerFees
          totalAmount
          gstAmount
          installment
          installments
          feeAmount
          reference
          paymentType
          taxAmount
          currency
          feeIds
          ipAddress
          status
          payerUserStatus
          declinedReason
          isUnlimitedRecurring
          payoutFailureReason
          payoutFailureFields
          payoutDetails {
            bank {
              id
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              country
            }
            bpay {
              billerCode
              referenceNumber
            }
          }
          scheduledAt
          paidAt
          declinedAt
          createdAt
          receivedAt
          paidOutAt
          updatedAt
          voidedAt
          owner
          payoutFailedAt
        }
        nextToken
      }
      createdBy
      entityIdBy
      dueAt
      issuedAt
      notes
      reviewerFeedback {
        reviewedById
        feedback
        status
        createdAt
      }
      direction
      readBy
      gstInclusive
      isUnlimitedRecurring
      owner
      lineItems {
        serviceId
        description
        quantity
        unitAmount
        taxType
        lineAmount
        newService
      }
      xeroTenantId
      sendSMS
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      sendTemplate
      includeLetterhead
      templateJson
      templateHtml
      paymentAt
      lodgementAt
      period
      year
      createdAt
      updatedAt
      viewedAt
      readAt
      paidAt
      endAt
      quoteAcceptedAt
      completedAt
      payoutErrors
    }
  }
`;
export const createBindingTask = /* GraphQL */ `
  mutation CreateBindingTask($input: CreateBindingTaskInput) {
    createBindingTask(input: $input) {
      entityId
      taskNumber
      invoiceStatus
      agreementUuid
      documentType
      subCategory
      id
      linkedTaskId
      managerId
      partnerId
      bindingId
      futureLinkedTask {
        fromId
        fromType
        toId
        toType
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      documentAnalysisId
      activity {
        items {
          id
          compositeId
          userId
          entityId
          type
          message
          metadata {
            name
            email
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      amount
      taxAmount
      annotations
      entityIdFrom
      fromId
      fromType
      toId
      toType
      firmId
      entityIdTo
      contactIdFrom
      contactIdTo
      contactId
      entityByIdContactId
      firmByIdContactId
      firmById
      searchName
      status
      quoteStatus
      signatureStatus
      paymentStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      emailMessage
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      maximumInstallments
      reference
      bpayReferenceNumber
      settlementStatus
      signers {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      otherRecipients {
        email
        sendOnCompletion
      }
      payments {
        items {
          id
          paymentIntentId
          taskId
          entityId
          payInPaymentId
          providerTransactionId
          paymentProvider
          disbursementId
          fromId
          fromType
          toId
          toType
          buyerId
          sellerId
          entityIdTo
          amount
          netAmount
          payerFees
          totalAmount
          gstAmount
          installment
          installments
          feeAmount
          reference
          paymentType
          taxAmount
          currency
          feeIds
          ipAddress
          status
          payerUserStatus
          declinedReason
          isUnlimitedRecurring
          payoutFailureReason
          payoutFailureFields
          payoutDetails {
            bank {
              id
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              country
            }
            bpay {
              billerCode
              referenceNumber
            }
          }
          scheduledAt
          paidAt
          declinedAt
          createdAt
          receivedAt
          paidOutAt
          updatedAt
          voidedAt
          owner
          payoutFailedAt
        }
        nextToken
      }
      createdBy
      entityIdBy
      dueAt
      issuedAt
      notes
      reviewerFeedback {
        reviewedById
        feedback
        status
        createdAt
      }
      direction
      readBy
      gstInclusive
      isUnlimitedRecurring
      owner
      lineItems {
        serviceId
        description
        quantity
        unitAmount
        taxType
        lineAmount
        newService
      }
      xeroTenantId
      sendSMS
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      sendTemplate
      includeLetterhead
      templateJson
      templateHtml
      paymentAt
      lodgementAt
      period
      year
      createdAt
      updatedAt
      viewedAt
      readAt
      paidAt
      endAt
      quoteAcceptedAt
      completedAt
      payoutErrors
    }
  }
`;
export const updateBindingTask = /* GraphQL */ `
  mutation UpdateBindingTask($input: UpdateBindingTaskInput) {
    updateBindingTask(input: $input) {
      id
      sendTemplate
      sendSMS
      status
      emailMessage
      createdAt
      updatedAt
      documents {
        identityId
        key
        level
        type
        name
      }
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask($input: UpdateTaskInput) {
    updateTask(input: $input) {
      entityId
      taskNumber
      invoiceStatus
      agreementUuid
      documentType
      subCategory
      id
      linkedTaskId
      managerId
      partnerId
      bindingId
      futureLinkedTask {
        fromId
        fromType
        toId
        toType
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      documentAnalysisId
      activity {
        items {
          id
          compositeId
          userId
          entityId
          type
          message
          metadata {
            name
            email
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      amount
      taxAmount
      annotations
      entityIdFrom
      fromId
      fromType
      toId
      toType
      firmId
      entityIdTo
      contactIdFrom
      contactIdTo
      contactId
      entityByIdContactId
      firmByIdContactId
      firmById
      searchName
      status
      quoteStatus
      signatureStatus
      paymentStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      emailMessage
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      maximumInstallments
      reference
      bpayReferenceNumber
      settlementStatus
      signers {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      otherRecipients {
        email
        sendOnCompletion
      }
      payments {
        items {
          id
          paymentIntentId
          taskId
          entityId
          payInPaymentId
          providerTransactionId
          paymentProvider
          disbursementId
          fromId
          fromType
          toId
          toType
          buyerId
          sellerId
          entityIdTo
          amount
          netAmount
          payerFees
          totalAmount
          gstAmount
          installment
          installments
          feeAmount
          reference
          paymentType
          taxAmount
          currency
          feeIds
          ipAddress
          status
          payerUserStatus
          declinedReason
          isUnlimitedRecurring
          payoutFailureReason
          payoutFailureFields
          payoutDetails {
            bank {
              id
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              country
            }
            bpay {
              billerCode
              referenceNumber
            }
          }
          scheduledAt
          paidAt
          declinedAt
          createdAt
          receivedAt
          paidOutAt
          updatedAt
          voidedAt
          owner
          payoutFailedAt
        }
        nextToken
      }
      createdBy
      entityIdBy
      dueAt
      issuedAt
      notes
      reviewerFeedback {
        reviewedById
        feedback
        status
        createdAt
      }
      direction
      readBy
      gstInclusive
      isUnlimitedRecurring
      owner
      lineItems {
        serviceId
        description
        quantity
        unitAmount
        taxType
        lineAmount
        newService
      }
      xeroTenantId
      sendSMS
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      sendTemplate
      includeLetterhead
      templateJson
      templateHtml
      paymentAt
      lodgementAt
      period
      year
      createdAt
      updatedAt
      viewedAt
      readAt
      paidAt
      endAt
      quoteAcceptedAt
      completedAt
      payoutErrors
    }
  }
`;
export const updateTaskPublic = /* GraphQL */ `
  mutation UpdateTaskPublic($input: UpdateTaskPublicInput) {
    updateTaskPublic(input: $input) {
      id
      entityId
      amount
      taxAmount
      annotations
      documentType
      subCategory
      fromId
      linkedTaskId
      futureLinkedTask {
        fromId
        fromType
        from {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toId
        toType
        to {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      firm {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      fromEntity {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      from {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      fromContact {
        id
        firstName
        lastName
        name
        createdAt
        updatedAt
      }
      fromType
      toEntity {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      toContact {
        id
        firstName
        lastName
        name
        createdAt
        updatedAt
      }
      toId
      to {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      toType
      isFinalSigner
      status
      signatureStatus
      paymentStatus
      quoteStatus
      invoiceStatus
      settlementStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      reference
      bpayReferenceNumber
      createdBy
      gstInclusive
      entityIdBy
      dueAt
      issuedAt
      notes
      direction
      paymentAt
      lodgementAt
      readAt
      paidAt
      quoteAcceptedAt
      completedAt
      owner
      metaHashData
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      termsFirmPayTaxAccepted
      createdAt
      updatedAt
      token
      period
      year
    }
  }
`;
export const regenerateTaskPublicLink = /* GraphQL */ `
  mutation RegenerateTaskPublicLink($token: ID!) {
    regenerateTaskPublicLink(token: $token)
  }
`;
export const regenerateBindingPublicLink = /* GraphQL */ `
  mutation RegenerateBindingPublicLink($token: ID!) {
    regenerateBindingPublicLink(token: $token)
  }
`;
export const createTaskDocumentUrl = /* GraphQL */ `
  mutation CreateTaskDocumentUrl($input: CreateTaskDocumentUrlInput) {
    createTaskDocumentUrl(input: $input) {
      url
      expiresAt
    }
  }
`;
export const createTaskDocumentUrlGuest = /* GraphQL */ `
  mutation CreateTaskDocumentUrlGuest($input: CreateTaskDocumentUrlGuestInput) {
    createTaskDocumentUrlGuest(input: $input) {
      url
      expiresAt
    }
  }
`;
export const createTaskViewedGuest = /* GraphQL */ `
  mutation CreateTaskViewedGuest($input: CreateTaskViewedGuestInput) {
    createTaskViewedGuest(input: $input)
  }
`;
export const createTaskSupportDocumentUrl = /* GraphQL */ `
  mutation CreateTaskSupportDocumentUrl(
    $input: CreateTaskSupportDocumentUrlInput
  ) {
    createTaskSupportDocumentUrl(input: $input) {
      url
      expiresAt
    }
  }
`;
export const createTaskSupportDocumentUrlGuest = /* GraphQL */ `
  mutation CreateTaskSupportDocumentUrlGuest(
    $input: CreateTaskSupportDocumentUrlGuestInput
  ) {
    createTaskSupportDocumentUrlGuest(input: $input) {
      url
      expiresAt
    }
  }
`;
export const createBindingTemplateUrlGuest = /* GraphQL */ `
  mutation CreateBindingTemplateUrlGuest(
    $input: CreateBindingTemplateUrlGuestInput
  ) {
    createBindingTemplateUrlGuest(input: $input) {
      url
      expiresAt
    }
  }
`;
export const generateHash = /* GraphQL */ `
  mutation GenerateHash($input: GenerateHashInput) {
    generateHash(input: $input)
  }
`;
export const generateSignatureUrl = /* GraphQL */ `
  mutation GenerateSignatureUrl($input: GenerateSignatureUrlInput) {
    generateSignatureUrl(input: $input)
  }
`;
export const createUploadTaskUrlGuest = /* GraphQL */ `
  mutation CreateUploadTaskUrlGuest($input: CreateUploadTaskUrlGuestInput) {
    createUploadTaskUrlGuest(input: $input) {
      url
    }
  }
`;
export const createUploadTaskUrl = /* GraphQL */ `
  mutation CreateUploadTaskUrl($input: CreateUploadTaskUrlInput) {
    createUploadTaskUrl(input: $input) {
      url
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput) {
    updateUser(input: $input) {
      id
      identityId
      referralCode
      referredBy
      email
      about
      firstName
      firmId
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locale
      onboardingStatus
      onboardingEntity
      selectedEntityId
      selectedSignatureKey
      signatures {
        items {
          id
          userId
          key
          createdAt
          updatedAt
        }
        nextToken
      }
      userType
      rating
      reportReasons
      notificationPreferences {
        email
        push
        sms
      }
      paymentUserId
      providerWalletId
      providerNppCrn
      ipAddress
      createdAt
      updatedAt
      owner
      loyaltyStatus
      nextLoyaltyStatus
      nextLoyaltyStatusPoint
      statusPoint
      pointsTotal
      pointsBalance
      invitedTo
    }
  }
`;
export const blockUser = /* GraphQL */ `
  mutation BlockUser($input: BlockUserInput) {
    blockUser(input: $input) {
      id
      identityId
      referralCode
      referredBy
      email
      about
      firstName
      firmId
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locale
      onboardingStatus
      onboardingEntity
      selectedEntityId
      selectedSignatureKey
      signatures {
        items {
          id
          userId
          key
          createdAt
          updatedAt
        }
        nextToken
      }
      userType
      rating
      reportReasons
      notificationPreferences {
        email
        push
        sms
      }
      paymentUserId
      providerWalletId
      providerNppCrn
      ipAddress
      createdAt
      updatedAt
      owner
      loyaltyStatus
      nextLoyaltyStatus
      nextLoyaltyStatusPoint
      statusPoint
      pointsTotal
      pointsBalance
      invitedTo
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount {
    deleteAccount {
      id
      identityId
      referralCode
      referredBy
      email
      about
      firstName
      firmId
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locale
      onboardingStatus
      onboardingEntity
      selectedEntityId
      selectedSignatureKey
      signatures {
        items {
          id
          userId
          key
          createdAt
          updatedAt
        }
        nextToken
      }
      userType
      rating
      reportReasons
      notificationPreferences {
        email
        push
        sms
      }
      paymentUserId
      providerWalletId
      providerNppCrn
      ipAddress
      createdAt
      updatedAt
      owner
      loyaltyStatus
      nextLoyaltyStatus
      nextLoyaltyStatusPoint
      statusPoint
      pointsTotal
      pointsBalance
      invitedTo
    }
  }
`;
export const xeroCreateConsentUrl = /* GraphQL */ `
  mutation XeroCreateConsentUrl($input: XeroCreateConsentUrlInput) {
    xeroCreateConsentUrl(input: $input)
  }
`;
export const xeroCreateContactSync = /* GraphQL */ `
  mutation XeroCreateContactSync($input: XeroCreateContactSyncInput) {
    xeroCreateContactSync(input: $input)
  }
`;
export const xeroCreateInvoiceSync = /* GraphQL */ `
  mutation XeroCreateInvoiceSync($input: XeroCreateInvoiceSyncInput) {
    xeroCreateInvoiceSync(input: $input)
  }
`;
export const xeroCreateTenantsConnect = /* GraphQL */ `
  mutation XeroCreateTenantsConnect($input: xeroCreateTenantsConnectInput) {
    xeroCreateTenantsConnect(input: $input)
  }
`;
export const xeroGetProfile = /* GraphQL */ `
  mutation XeroGetProfile($input: XeroGetProfileInput) {
    xeroGetProfile(input: $input)
  }
`;
export const xeroDisconnect = /* GraphQL */ `
  mutation XeroDisconnect($input: XeroDisconnectInput) {
    xeroDisconnect(input: $input)
  }
`;
export const emailCreateConsentUrl = /* GraphQL */ `
  mutation EmailCreateConsentUrl($input: EmailCreateConsentUrlInput) {
    emailCreateConsentUrl(input: $input)
  }
`;
export const emailDisconnectProvider = /* GraphQL */ `
  mutation EmailDisconnectProvider($entityId: ID!, $provider: String!) {
    emailDisconnectProvider(entityId: $entityId, provider: $provider)
  }
`;
export const createBeneficiary = /* GraphQL */ `
  mutation CreateBeneficiary($input: CreateBeneficiaryInput) {
    createBeneficiary(input: $input)
  }
`;
export const createPaymentIntent = /* GraphQL */ `
  mutation CreatePaymentIntent($input: CreatePaymentIntentInput) {
    createPaymentIntent(input: $input)
  }
`;
export const updatePaymentIntent = /* GraphQL */ `
  mutation UpdatePaymentIntent($input: UpdatePaymentIntentInput) {
    updatePaymentIntent(input: $input)
  }
`;
export const createPaymentIntentGuest = /* GraphQL */ `
  mutation CreatePaymentIntentGuest($input: CreatePaymentIntentGuestInput) {
    createPaymentIntentGuest(input: $input)
  }
`;
export const getAuthCode = /* GraphQL */ `
  mutation GetAuthCode($input: GetAuthCodeInput!) {
    getAuthCode(input: $input)
  }
`;
export const addFundsInWallet = /* GraphQL */ `
  mutation AddFundsInWallet($input: AddFundsInWalletInput) {
    addFundsInWallet(input: $input)
  }
`;
export const capturePaymentIntent = /* GraphQL */ `
  mutation CapturePaymentIntent($input: CapturePaymentIntentInput) {
    capturePaymentIntent(input: $input)
  }
`;
export const amountTransfer = /* GraphQL */ `
  mutation AmountTransfer($input: AmountTransferInput) {
    amountTransfer(input: $input)
  }
`;
export const retryPayoutTransfer = /* GraphQL */ `
  mutation RetryPayoutTransfer($input: RetryPayoutTransferInput) {
    retryPayoutTransfer(input: $input) {
      id
      paymentIntentId
      taskId
      entityId
      payInPaymentId
      providerTransactionId
      paymentProvider
      disbursementId
      fromId
      fromType
      toId
      toType
      buyerId
      sellerId
      entityIdTo
      amount
      netAmount
      payerFees
      totalAmount
      gstAmount
      installment
      installments
      feeAmount
      reference
      paymentType
      taxAmount
      currency
      feeIds
      ipAddress
      status
      payerUserStatus
      declinedReason
      isUnlimitedRecurring
      payoutFailureReason
      payoutFailureFields
      payoutDetails {
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      scheduledAt
      paidAt
      declinedAt
      createdAt
      receivedAt
      paidOutAt
      updatedAt
      voidedAt
      owner
      payoutFailedAt
    }
  }
`;
export const resendRemittence = /* GraphQL */ `
  mutation ResendRemittence($input: ResendRemittenceInput) {
    resendRemittence(input: $input) {
      id
      paymentIntentId
      taskId
      entityId
      payInPaymentId
      providerTransactionId
      paymentProvider
      disbursementId
      fromId
      fromType
      toId
      toType
      buyerId
      sellerId
      entityIdTo
      amount
      netAmount
      payerFees
      totalAmount
      gstAmount
      installment
      installments
      feeAmount
      reference
      paymentType
      taxAmount
      currency
      feeIds
      ipAddress
      status
      payerUserStatus
      declinedReason
      isUnlimitedRecurring
      payoutFailureReason
      payoutFailureFields
      payoutDetails {
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      scheduledAt
      paidAt
      declinedAt
      createdAt
      receivedAt
      paidOutAt
      updatedAt
      voidedAt
      owner
      payoutFailedAt
    }
  }
`;
export const notifyClient = /* GraphQL */ `
  mutation NotifyClient($input: NotifyClientInput) {
    notifyClient(input: $input)
  }
`;
